import { Avatar } from "@maxhub/max-ui"
import { PlaceholderIcon } from "../shared/PlaceholderIcon"

export const AvatarCloseButtonExample = {
    title: 'Avatar.CloseButton',
    defaultPlatform: 'ios',
    defaultZoom: 100,

    controls: [
        {
            name: 'aria-label',
            label: 'aria-label',
            type: 'text',
            tsType: 'string',
            default: 'Закрыть',
        },
    ],

    Preview({ props }){
        const ariaLabel = props['aria-label']

        return (
            <Avatar.Container size={64} form="circle" rightTopCorner={<Avatar.CloseButton aria-label={ariaLabel} />}>
                <Avatar.Icon>
                    <PlaceholderIcon />
                </Avatar.Icon>
            </Avatar.Container>
        )
    },

    getCode(props){
        const ariaLabel = props['aria-label']

        return `<Avatar.Container rightTopCorner={<Avatar.CloseButton aria-label="${ariaLabel}" />}>
  <Avatar.Icon>
    <Icon24Placeholder />
  </Avatar.Icon>
</Avatar.Container>`
    }

}